import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Unauthorized() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Box sx={{ textAlign: 'center', py: 8 }}>
      <Typography variant="h5">{t('errors.accessDenied')}</Typography>
      <Typography color="text.secondary" sx={{ mt: 1 }}>
        {t('errors.noAccessToPage')}
      </Typography>
      <Button variant="contained" sx={{ mt: 2 }} onClick={() => navigate('/dashboard')}>
        {t('common.toDashboard')}
      </Button>
    </Box>
  );
}
